import { Avatar, Badge } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useChatContext } from "stream-chat-react";
import styled from "styled-components";

import UserBadge from "../UserBadge/UserBadge";

const UnreadBadge = styled(Badge)`
  .ant-badge-count {
    box-shadow: none;
  }
`;

const CountTile = styled(Avatar)`
  background-color: #8c8c8c;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
`;

function HideButton({ channel }) {
  const onHide = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (channel?.hide) channel.hide();
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      onHide(e);
    }
  };
  return (
    <span
      role="button"
      tabIndex={-1}
      aria-label="Hide channel"
      className="channel-preview__hide"
      onClick={onHide}
      onKeyDown={onKeyDown}
    >
      <CloseOutlined />
    </span>
  );
}

export default function DirectMessagingChannelPreview({ channel }) {
  const { client } = useChatContext();

  // Ensure members is always an array of objects with a user property
  const members = Object.values(channel.state.members).filter(
    (member) =>
      member && typeof member === "object" && member.user && member.user.id !== client.userID,
  );
  const defaultName = "Some random test user name";
  let displayText;

  if (!members.length || members.length === 1) {
    const member = members[0];
    displayText =
      (member && member.user && member.user.name) ||
      (member && member.user && member.user.id) ||
      defaultName;
    const unreadCount = channel.countUnread();
    const unreadCountMessage = unreadCount > 0 ? `${unreadCount} unread messages` : null;
    return (
      <div className="channel-preview__item single" title={displayText}>
        <UserBadge
          image={member && member.user && member.user.image}
          name={
            (member && member.user && member.user.name) || (member && member.user && member.user.id)
          }
          userId={member && member.user && member.user.id}
          size={24}
        />
        <p>{displayText}</p>
        {unreadCount > 0 && (
          <UnreadBadge
            className="channel-preview__unread"
            title={unreadCountMessage}
            count={unreadCount}
            color="#ff7875"
          />
        )}
        <HideButton channel={channel} />
      </div>
    );
  }

  const nameFor = (m) => (m && m.user && m.user.name) || (m && m.user && m.user.id) || defaultName;
  const extraCount = members.length - 2;
  const nameList = [nameFor(members[0]), nameFor(members[1])].filter(Boolean).join(", ");
  displayText =
    channel.data?.name || (extraCount > 0 ? `${nameList}, +${extraCount} more` : nameList);

  return (
    <div className="channel-preview__item multi" title={displayText}>
      <CountTile shape="square" size={24}>
        {members.length}
      </CountTile>
      <p>{displayText}</p>
      <HideButton channel={channel} />
    </div>
  );
}
